import Faqs from "../component/faq"
import News from "../component/news"
function Faqdrop(){
    return(
        <>
        <Faqs/>
        <News/>
        </>

    )
}
export default Faqdrop